import {
  USERS_GET_PREFS_REQUEST,
  USERS_GET_PREFS_SUCCESS,
  USERS_GET_PREFS_FAILURE,
  
  USERS_SET_PREFS_REQUEST,
  USERS_SET_PREFS_SUCCESS,
  USERS_SET_PREFS_FAILURE,
} from "./prefs_actions";

import _ from "lodash";

import createReducer from "state/createReducer";

const initialState = {
  request: false,
  errorMessage: null,
  prefs: {}
};

const handlers = {
  [USERS_GET_PREFS_REQUEST](state) {
    return {
      ...state,
      request: true,
    };
  },
  [USERS_SET_PREFS_REQUEST](state) {
    return {
      ...state,
      request: true,
    };
  },

  [USERS_GET_PREFS_SUCCESS](state, payload) {
    const prefs = { ...state.prefs };
    prefs[payload.prefType] = payload.data;

    return {
      ...state,
      request: false,
      prefs: prefs,
    };
  },

  [USERS_SET_PREFS_SUCCESS](state, payload) {
    const prefs = { ...state.prefs };
    prefs[payload.prefType] = payload.prefs;

    return {
      ...state,
      request: false,
      prefs: prefs,
    };
  },

  [USERS_GET_PREFS_FAILURE](state) {
    return {
      ...state,
      request: false,
    };
  },

  [USERS_SET_PREFS_FAILURE](state) {
    return {
      ...state,
      request: false,
    };
  },
};

export default (state = initialState, action) => createReducer(state, action, handlers);